<div class="social-network-icon">
  <div class="social-network-icon__icon" [attr.data-sn-type]="type"></div>
  <div class="social-network-icon__text">{{ displayText ? labelText : '' }}</div>
</div>
